export default "__VITE_ASSET__BiAa3$34__"